import { inject, Injectable } from "@angular/core";
import { AuthService } from "@app/shared/auth/services/auth.service";
import { TicketService } from "@shared-core/general/queue/ticket/services/ticket.service";

/**
 * Orchestrator for kiosk session lifecycle.
 *
 * `AuthService.clear()` wipes token + guestId + permissions + metadata in one
 * call; `TicketService.clear()` wipes the issued ticket. This service is the
 * single place that knows what "the session" is composed of — when a new
 * piece of session state is added, only `reset()` changes.
 */
@Injectable({ providedIn: "root" })
export class SessionService {
  private readonly authService = inject(AuthService);
  private readonly ticketService = inject(TicketService);

  /**
   * Wipes every piece of kiosk session state.
   * Called on a fresh guestLogin, on landing on /auth/unauthorized, and
   * on every 401 response from the global error interceptor.
   */
  reset(): void {
    this.authService.clear();
    this.ticketService.clear();
  }
}
